import "./Home.css";
import mypic from "../../Photos/Me2.png";

function Home({ darkMode }) {
    const handleDownload = () => {
        const resumePath = require("../../Resume/Oluwafisayo_Adabonyan_Master_Resume.pdf");
        window.open(resumePath, "_blank");
    };

    return (
        <section className={`home ${darkMode ? "dark" : ""}`} id="home">
            <div className="home-container">
                <div className="home-text">
                    <h1>
                        Oluwafisayo <span>Adabonyan</span>
                    </h1>

                    <p>
                        Software Engineering graduate from the University of
                        Calgary focused on building embedded systems, mobile
                        apps, and intelligent software.
                    </p>

                    <div className={`home-buttons ${darkMode ? "dark" : ""}`}>
                        <button onClick={handleDownload} className={`resume-buttons${darkMode ? "-dark" : ""}`}>Resume</button>
                        <a href="mailto:fisayoadabs@gmail.com">Contact</a>
                    </div>
                </div>

                <img className="home-image" src={mypic} alt="profile" />
            </div>
        </section>
    );
}

export default Home;
